import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Button from '../../Button'
import ComponentRenderer from '../../ComponentRenderer'

const StyledFeature = styled.li`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 48px;
  text-align: center;
  width: 100%;

  :last-child {
    margin-bottom: 0;
  }

  ${({ theme }) => theme.media.desktop} {
    flex-basis: 0;
    flex-grow: 1;
    margin-top: ${({ wide }) => (wide ? '37px' : 0)};
    width: initial;

    :nth-child(1), :nth-child(2), :nth-child(3) {
      margin-bottom: 80px;
    }

    :nth-child(4), :nth-child(5), :nth-child(6) {
      margin-bottom: 0;
    }
  }
`

const StyledTitle = styled.h3`
  color: ${({ theme }) => theme.colors.titleFontColor};
  font-size: 1.25em;
  font-weight: 500;
  line-height: 1.6;
  margin-bottom: 8px;
`

const StyledSubtitle = styled.p`
  color: ${({ theme }) => theme.colors.greyParagraphColor};
  display: inline-block;
  font-size: 0.875em;
  line-height: 1.71;
  padding: 0px 10%;

  ${({ theme }) => theme.media.desktop} {
    padding: 0;
    width: ${({ wide }) => (wide ? '100%' : '83%')};
  }
`

const StyledIcon = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 22px;
  padding-top: 48px;
  position: relative;
  transform: translateX(24px);
`

const StyledImage = styled.img.attrs(props => ({
  src: props.src,
  alt: props.alt,
}))`
  bottom: 0px;
  position: absolute;
  transform: translateX(-24px);
`

const StyledWrapper = styled.div`
  padding-top: 0;

  ${({ theme }) => theme.media.desktop} {
    padding-top: 88px;
  }
`

const StyledButtons = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 24px;

  a {
    margin-bottom: 8px;
  }
`

const FeatureIcon = ({ icon }) =>
  icon ? (
    <StyledIcon>
      <StyledImage
        alt={icon}
        src={icon.hasOwnProperty('sys') ? icon.fields.file.url : icon.file.url}
      />
    </StyledIcon>
  ) : null

const Feature = props => {
  const {
    buttonLink,
    buttons,
    buttonText,
    externalLink,
    icon,
    isAbsolutePath,
    subtitle,
    title,
  } = props.data
  
  return (
    <StyledFeature wide={props.wide}>
      <StyledWrapper>
        <FeatureIcon icon={icon} />
        <StyledTitle>{title}</StyledTitle>
        <StyledSubtitle wide={props.wide}>{subtitle}</StyledSubtitle>
      </StyledWrapper>
      <StyledButtons>
        {buttons &&
          buttons.map(button => (
            <h4>
              <ComponentRenderer
                cmsData={button.fields}
                key={button.sys.id}
                tag={button.sys.contentType.sys.id}
              />
            </h4>
          ))}
      </StyledButtons>
      {buttonText ? (
        <Button
          to={buttonLink}
          ghost="true"
          external={externalLink}
          isAbsolutePath={isAbsolutePath}
        >
          {buttonText}
        </Button>
      ) : (
        undefined
      )}
    </StyledFeature>
  )
}

Feature.propTypes = {
  data: PropTypes.object.isRequired,
}
export default Feature
